module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Italic.ttf?v=4f60322e8589cfe9b21da00a002339d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Italic.ttf
// module id = 650
// module chunks = 0